export interface BankFormat {
  bank: Bank
  displayName: string
}

export type Bank = "Rabobank" | "ABN" | "ASN" | "ASN2" | "ING" | "Triodos" | "Bunq"

export const bankFormats: BankFormat[] = [
  {bank: "Rabobank", displayName: "Rabobank"},
  {bank: "ABN", displayName: "ABN Amro"},
  {bank: "ASN", displayName: "ASN-bank"},
  {bank: "ING", displayName: "ING"},
  {bank: "Triodos", displayName: "Triodos"},
  {bank: "Bunq", displayName: "bunq"}
]
